<div class="confirmation-container">
    <!-- <div>{{config.data.title | translate}}</div> -->
    @if (config.data.showIcon) {
        <div class="icon-msg">
            <i class="icon" [ngClass]="{'success-icon': config.data.type === 'success', 'error-icon': config.data.type === 'error'}"></i>
        </div>
        
        <div class="msg-title">
            <h5 [ngClass]="{'success-msg': config.data.type === 'success', 'error-msg': config.data.type === 'error'}">{{ config.data.header | translate }}
            </h5>
        </div>
    }
    <div>
        <div [innerHTML]="config.data.content1 | translate"></div>
        @if (!config.data.textAreaAfterContent1) {
            <div [innerHTML]="config.data.content2 | translate"></div>
        }
        @if (config.data.content3) {
            <div [innerHTML]="config.data.content3 | translate"></div>
        }
        @if (config.data.content4) {
            <div [innerHTML]="config.data.content4 | translate"></div>
        }

        @if (config.data.textarea) {
            <div class="row">
                <div class="col-12">
                    <div class="text-area">
                        <textarea pTextarea rows="5" cols="85" [readonly]="true" [value]="config.data.textvalue"></textarea>
                    </div>
                </div>
            </div>
        }
        @if (config.data.editableTextarea) {
            <div class="row">
                <div class="col-12">
                    <div class="text-area mt-1">
                        <p>{{config.data.textareaHeader | translate}}</p>
                        <textarea pTextarea rows="5" cols="85" placeholder="{{'PLEASE_ENTER' | translate}}" [(ngModel)]="editableTextValue"></textarea>
                    </div>
                </div>
            </div>
        }
    </div>

    @if (config.data.selectDropdown) {
        <div class="dropdown-container">
            <label class="required-label">{{config.data.selectDropdownHeader | translate}}</label>
            <p-select appendTo="body" [options]="config.data.dropdownList" optionValue="id" optionLabel="description" [(ngModel)]="selectDropdownId"></p-select>
        </div>
    }
    @if (config.data.multiselectDropdown) {
        <div class="dropdown-container">
            <label class="required-label">{{config.data.multiselectDropdownHeader | translate}}</label>
            <p-multiselect appendTo="body" [options]="config.data.dropdownList" optionValue="id" optionLabel="description" [(ngModel)]="multiselectDropdownIds"></p-multiselect>
        </div>
    }

    @if (config.data.textAreaAfterContent1 === true) {
        <div [innerHTML]="config.data.content2 | translate"></div>
    }
    <div class="btn-container">
        @if (config.data.showCancel) {
            <app-button type="secondary" label="{{'CANCEL' | translate}}" (click)="onCancel()" [disable]="isLoading"></app-button>
        }
        @if (!config.data.hideConfirm) {
            <app-button type="primary" label="{{config.data.primaryBtnLabel | translate}}" (click)="onPrimaryBtnClickEvent()" 
            [bypassPermCheck]="true" [showSpinner]="isLoading"
            [disable]="isLoading ||
            (config.data.editableTextarea && !editableTextValue?.trim()) ||
            (config.data.selectDropdown && !selectDropdownId) ||
            (config.data.multiselectDropdown && !multiselectDropdownIds?.length)" 
            ></app-button>
        }
    </div>
</div>